export function getCaseInfoById(state) {
  return caseId => {
    return state.caseInfos[caseId]
  };
}



// WEBPACK FOOTER //
// ./src/store/getters/case.js